import React from 'react';
import PropTypes from 'prop-types';
import { StyledDiv, StyledLink, StyledSpan } from './BackLink.styles';

const BackLink = ({ to, label, children }) => (
  <StyledDiv>
    <StyledLink to={to}>
      {'<'}
      <StyledSpan>{label || children}</StyledSpan>
    </StyledLink>
  </StyledDiv>
);

BackLink.propTypes = {
  to: PropTypes.string,
  label: PropTypes.node,
  children: PropTypes.node
};

export default BackLink;
